import React, { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import adoptionFairs from '@/services/api/adoptionFairs'
import { toast } from 'react-toastify'
import useModalAction from '../useModalAction'

function Destroy({ fair, onDestroy }) {
  const [loading, setLoading] = useState(false)
  const { active, close, open } = useModalAction()

  const onConfirm = useCallback(async () => {
    try {
      setLoading(true)
      const { data } = await adoptionFairs.destroy(fair.id)
      toast.success('Feira removida')
      setLoading(false)
      close()
      onDestroy(data)
    } catch (e) {
      toast.error(e?.message)
      setLoading(false)
    }
  }, [close, fair.id, onDestroy])

  return (
    <>
      <button type="button" className="btn btn-sm btn-error mx-1" onClick={open}>
        <i className="fas fa-trash" />
        &nbsp;Remover
      </button>
      <div className={`modal ${active ? 'active' : ''}`}>
        <a type="button" className="modal-overlay" aria-label="Close" onClick={close} />
        <div className="modal-container">
          <div className="modal-header">
            <a
              type="button"
              className="btn btn-clear float-right"
              onClick={close}
            />
            <div className="modal-title h5">
              Remover a feira de adoção
            </div>
          </div>
          <div className="modal-body">
            <div className="h3">Atenção</div>
            <p>
              A partir do momento que a feira for removida ela ficará inacessível.
            </p>
            <p>
              Você tem certeza que deseja <b>remover</b> esta feira de adoção?
              <b><br />{fair?.title}</b>
            </p>
          </div>
          <div className="modal-footer">
            <button
              className={`btn btn-error ${loading ? 'loading' : ''}`}
              disabled={loading}
              onClick={onConfirm}
              type="button"
            >
              <i className="fas fa-trash" />
              &nbsp;Remover feira
            </button>
          </div>
        </div>
      </div>
    </>
  )
}

Destroy.propTypes = {
  fair: PropTypes.objectOf(Object).isRequired,
  onDestroy: PropTypes.func,
}

Destroy.defaultProps = {
  onDestroy: () => { },
}

export default Destroy
